<template src="./template.html"></template>
<style src="./styles.scss" lang="scss" scoped></style>

<script>
  import { mapState, mapActions } from 'vuex'
  import SliderTile from '@/components/modules/occasions/OccasionsSliderTile'

  export default {
    name: 'OccasionsSlider',
    components: {
      SliderTile,
    },
    data() {
      return {
        feedLoaded: false,
        anniversariesLoaded: false,
        birthdaysLoaded: false,
      }
    },
    computed: {
      ...mapState('occasions', [
        'occasions',
        'anniversaries',
        'birthdays',
      ]),
    },
    created() {
      this.getFeed().then(data => { this.feedLoaded = true})
      this.getAnniversaries().then(data => { this.anniversariesLoaded = true})
      this.getBirthdays().then(data => { this.birthdaysLoaded = true})
    },
    methods: {
      ...mapActions('occasions', [
        'getFeed',
        'getAnniversaries',
        'getBirthdays',
      ]),
    },
  }
</script>
